import React from 'react';
function EventSearchInput(props) {
    return (React.createElement("div", null,
        React.createElement("input", { className: "border rounded p-1", type: "text", placeholder: "Search for an event" })));
}
export default EventSearchInput;
